import React from 'react';
import { Typography } from '@material-ui/core';
import { TextFormattedNumber } from 'components';
import { useStyles } from '../styles';
import QuotedSummaryItem from '../QuoteSummary/QuotedSummaryItem';


const QuoteTreatmentPlanTotals = ({ totals }) => {
  const classes = useStyles();
  const {
    subtotal,
    discountTotal,
    grandTotal,
    quoteDiscount
  } = totals;

  return (
    <div className="mt-4">
      <>
        <QuotedSummaryItem
          label="Subtotal"
          value={subtotal}
          prefix="$"
        />
        <QuotedSummaryItem
          label="Total Savings"
          value={discountTotal}
          prefix="$"
        />
        {!!quoteDiscount &&
        <QuotedSummaryItem
          label="Quote Discount"
          value={quoteDiscount}
          prefix="$"
        />
        }
        <div className="flex items-center justify-between mt-5 mb-2">
          <Typography variant="h4" className={`font-bold ${classes.customQuoteSummaryTypography}`}>
            TOTAL
          </Typography>
          <Typography variant="h4" align="right" className={`font-bold ${classes.customQuoteSummaryTypography}`}>
            <TextFormattedNumber
              value={grandTotal}
              prefix="$"
            />
          </Typography>
        </div>
      </>
    </div>
  );
};

export default QuoteTreatmentPlanTotals;
